import apiClient from './client';

export const taskService = {
    // Get my tasks (Default view)
    async getAll() {
        const data = await apiClient('me/tasks?limit=1000');
        return data.items || data;
    },

    // Get division tasks (Coordinator/DG)
    async getDivisionTasks(divisionId) {
        let query = divisionId ? `?division=${divisionId}&limit=1000` : '?limit=1000';
        const data = await apiClient(`division/tasks${query}`);
        return data.items || data;
    },

    // Get all tasks (DG)
    async getAllTasks() {
        const data = await apiClient('all/tasks?limit=1000');
        return data.items || data;
    },

    // Get single task details
    async getById(id) {
        return await apiClient(`tasks/${id}`);
    },

    // Create a new task
    async create(task) {
        return await apiClient('tasks', {
            method: 'POST',
            body: JSON.stringify(task)
        });
    },

    // Create a subtask
    async createSubTask(taskId, subTask) {
        return await apiClient(`tasks/${taskId}/subtasks`, {
            method: 'POST',
            body: JSON.stringify(subTask)
        });
    },

    // Get subtasks
    async getSubTasks(taskId) {
        const data = await apiClient(`tasks/${taskId}/subtasks`);
        if (Array.isArray(data)) return data;
        if (Array.isArray(data?.items)) return data.items;
        if (Array.isArray(data?.subtasks)) return data.subtasks;
        return [];
    },

    // Update subtask status or add comment
    async updateSubTask(subTaskId, payload) {
        const body = typeof payload === 'string' ? { status: payload } : payload;
        return await apiClient(`subtasks/${subTaskId}`, {
            method: 'PUT',
            body: JSON.stringify(body)
        });
    },

    // Get Gantt/Hierarchy view
    async getGantt() {
        return await apiClient('gantt');
    },

    // Update a task
    async update(taskId, taskData) {
        return await apiClient(`tasks/${taskId}`, {
            method: 'PUT',
            body: JSON.stringify(taskData),
        });
    },
    async prepareAttachment(taskId, file, category) {
        return await apiClient(`tasks/${taskId}`, {
            method: 'PUT',
            body: JSON.stringify({
                action: 'PRESIGN_UPLOAD',
                fileName: file?.name,
                contentType: file?.type || 'application/octet-stream',
                sizeBytes: file?.size || 0,
                category
            }),
        });
    },
    async commitAttachment(taskId, attachment) {
        return await apiClient(`tasks/${taskId}`, {
            method: 'PUT',
            body: JSON.stringify({
                action: 'COMMIT_ATTACHMENT',
                attachment
            }),
        });
    },
    async getAttachmentUrl(taskId, attachmentId, options = {}) {
        return await apiClient(`tasks/${taskId}`, {
            method: 'PUT',
            body: JSON.stringify({
                action: 'PRESIGN_DOWNLOAD',
                attachmentId,
                download: !!options.download
            }),
        });
    },
    async deleteAttachment(taskId, attachmentId) {
        return await apiClient(`tasks/${taskId}`, {
            method: 'PUT',
            body: JSON.stringify({
                action: 'DELETE_ATTACHMENT',
                attachmentId
            }),
        });
    }
};
